import { render, staticRenderFns } from "./EditorialStatistics.vue?vue&type=template&id=7efab5d8&"
import script from "./EditorialStatistics.vue?vue&type=script&lang=js&"
export * from "./EditorialStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EditorialStatistics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports